import { action, computed, observable } from 'mobx';

import { PROMO_CODES } from '../constants/promoCodes';


class CampaignStore {
  @observable currentCampaign = {};
  @observable campaignToShowOnHomePage = {};
  @observable allActiveCampaigns = [];

  getCampaignCheckoutUrl = (campaign) => {
    let defaultPath = '/account/purchase';
    if (campaign?.affiliateCode === PROMO_CODES.MARCHMADNESS2026) {
      const params = new URLSearchParams({ promoCode: campaign.affiliateCode });
      defaultPath = '/2026-march-madness-promo';

      return `${defaultPath}?${params.toString()}`;
    }

    return defaultPath;
  };

  @computed
  get membersCampaign() {
    return this.allActiveCampaigns?.find(
      (campaign) => campaign?.affiliateCode === PROMO_CODES.NNLXMAS2025
    );
  }

  getHomePageCampaignForUser = (user, allActiveCampaigns) => {
    const campaign = allActiveCampaigns?.find(
      (activeCampaign) =>
        activeCampaign?.affiliateCode === PROMO_CODES.AUGUST_PROMO_2026
    );
    if (campaign?.name) {
      campaign.checkoutUrl = this.getCampaignCheckoutUrl(campaign);
    }

    return campaign;
  };

  findCampaignByCode = (affiliateCode) =>
    this.allActiveCampaigns?.find((c) => c.affiliateCode === affiliateCode);

  @action setCampaignByPage = (currentPathName, anchorToSubscribe) => {
    const promoCode = new URLSearchParams(window.location.search).get(
      'promoCode'
    );

    const campaignMappings = [
      {
        condition: () => currentPathName.includes('/affiliate/anchor-signup'),
        action: () =>
          this.findCampaignByCode(PROMO_CODES.ANCHOR_AFFILIATE) || {},
      },
      {
        condition: () => currentPathName.includes('/lifetime-offer') && !anchorToSubscribe,
        action: () =>
          this.findCampaignByCode(PROMO_CODES.NNLIFETIME2026) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/2026-march-madness-promo') &&
          !anchorToSubscribe,
        action: () =>
          this.findCampaignByCode(PROMO_CODES.MARCHMADNESS2026) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          !anchorToSubscribe && !promoCode,
        action: () =>
          this.findCampaignByCode(PROMO_CODES.AUGUST_PROMO_2026) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          !anchorToSubscribe &&
          currentPathName.includes(PROMO_CODES.NNLIVEBSSV),
        action: () =>
          this.findCampaignByCode(PROMO_CODES.NNLIVEBSSV) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          !anchorToSubscribe &&
          currentPathName.includes(PROMO_CODES.NN_HOLIDAY_AFF_2025),
        action: () =>
          this.findCampaignByCode(PROMO_CODES.NN_HOLIDAY_AFF_2025) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          !anchorToSubscribe &&
          currentPathName.includes(PROMO_CODES.NNLIVEBSBF),
        action: () => this.findCampaignByCode(PROMO_CODES.NNLIVEBSBF) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          currentPathName.includes(PROMO_CODES.NNLIVEMRSK7),
        action: () => this.findCampaignByCode(PROMO_CODES.NNLIVEMRSK7) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/account/purchase') &&
          currentPathName.includes(PROMO_CODES.NNLIVEFPN) &&
          !anchorToSubscribe,
        action: () => this.findCampaignByCode(PROMO_CODES.NNLIVEFPN) || {},
      },
      {
        condition: () =>
          currentPathName.includes('/lifetime-nnl-bundle') &&
          !anchorToSubscribe,
        action: () => this.findCampaignByCode(promoCode) || {},
      },
    ];

    this.currentCampaign =
      campaignMappings.find(({ condition }) => condition())?.action() || {};
  };

  @action setCurrentCampaign = (user, allActiveCampaigns) => {
    this.campaignToShowOnHomePage = this.getHomePageCampaignForUser(
      user,
      allActiveCampaigns
    );
    this.allActiveCampaigns = allActiveCampaigns;
  };
}

export default new CampaignStore();
